import {
  Box,
  Button,
  Paper,
  TableContainer,
  TextField,
  Typography,
  Modal,
  IconButton,
} from "@mui/material";
import { useUserData } from "components/customHooks/userDataContext";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close"; // Importing a close icon
import { DataGrid } from "@mui/x-data-grid";
import { DataGridCustomPagination } from "components/helpers";
import {
  addCareOpportunityNote,
  getCareOpportunityNotes,
} from "apiHandler/actions/clinical";

const Notes = ({ details }) => {
  const [notes, setNotes] = useState([]);
  const [newNote, setNewNote] = useState("");
  const [loading, setLoading] = useState(true); // Loading state
  const [openModal, setOpenModal] = useState(false); // Modal open state
  const userData = useUserData();

  const token = userData?.access_token;
  const name = userData.first_name + " " + userData.last_name;

  useEffect(() => {
    fetchNotes();
  }, [details?.care_oppt_id]);

  const fetchNotes = async () => {
    setLoading(true); // Start loading
    const payload = {
      type: "CareOpportunity",
      practice_id: `${userData.selected_practice}`,
      care_oppt_id: `${details?.care_oppt_id}`,
    };
    const response = await getCareOpportunityNotes(payload, token);

    if (response) {
      setNotes(response);
    }
    setLoading(false); // Stop loading
  };

  const handleAddNote = async () => {
    if (newNote.trim()) {
      const payload = {
        type: "CareOpportunity",
        practice_id: `${userData.selected_practice}`,
        care_oppt_id: `${details?.care_oppt_id}`,
        user_name: name,
        notes: newNote,
      };
      const response = await addCareOpportunityNote(payload, token);

      if (response.status === "successfull") {
        setNewNote("");
        fetchNotes();
        setOpenModal(false);
      }
    }
  };

  const handleOpenModal = () => {
    setOpenModal(true); // Open the modal
  };

  const handleCloseModal = () => {
    setOpenModal(false); // Close the modal
  };

  const columns = [
    {
      field: "care_oppt_notes_id",
      headerName: "ID",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "notes",
      headerName: "Notes",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "created_date",
      headerName: "Created Date",
      minWidth: 100,
      flex: 1,
      valueFormatter: (value) => {
        if (!value) {
          return;
        }
        return dayjs(value).format("MM/DD/YYYY");
      },
    },
    {
      field: "created_by",
      headerName: "Created By",
      minWidth: 100,
      flex: 1,
    },
  ];

  return (
    <Box mt={4}>
      <Typography variant="h6" gutterBottom>
        Notes
      </Typography>
      <Box display="flex" justifyContent="flex-end" mb={2}>
        <Button variant="text" size="small" onClick={handleOpenModal}>
          Add +
        </Button>
      </Box>
      <TableContainer component={Paper}>
        <DataGrid
          pageSize={10}
          density="compact"
          rows={notes}
          columns={columns}
          loading={loading}
          autoHeight
          disableRowSelectionOnClick
          pagination
          getRowId={(row) => row.care_oppt_notes_id}
          pageSizeOptions={[10, 50, 100]}
          initialState={{
            pagination: { paginationModel: { pageSize: 10 } },
          }}
          slots={{
            pagination: DataGridCustomPagination,
          }}
        />
      </TableContainer>

      {/* Modal for adding a new note */}
      <Modal open={openModal} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            borderRadius: 1,
            boxShadow: 24,
            p: 3,
            width: "400px",
          }}
        >
          <Box display="flex" justifyContent="flex-end">
            <IconButton onClick={handleCloseModal}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Typography variant="h6" gutterBottom>
            Add New Note
          </Typography>
          <TextField
            label="Note"
            value={newNote}
            onChange={(e) => setNewNote(e.target.value)}
            fullWidth
            multiline
            rows={4}
            variant="outlined"
          />
          <Box display="flex" justifyContent="flex-end" mt={2}>
            <Button
              variant="contained"
              onClick={handleAddNote}
              disabled={newNote.trim().length === 0}
            >
              Add Note
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default Notes;
